export const GIFT_CARD_PREDETERMINED_AMOUNTS = [75, 100, 125];
export const GIFT_CARD_RANGE = { min: 25, max: 500 };
export const GIFT_CARD_LOCAL_STORAGE_KEY = 'giftCardAmount';
export const SEGMENT_EVENT_GIFT_CARD = {
  product: {
    id: 'gift_card',
    sku: 'gift_card',
    name: 'Gift Card',
  },
};

export const GIFT_CARD_FAQ: {
  question: string;
  answer: string;
  disabled?: boolean;
}[] = [
  {
    question: 'How do I purchase a gift card?',
    answer:
      'To purchase a gift card, visit our Purchase Page and select a pre-determined amount or type in an amount between $25 - $500 then follow the checkout process. Once your purchase is complete, you’ll receive a confirmation email with the gift card details, including the amount and a unique code that you can share with your recipient.',
  },
  {
    question: 'How do I redeem a gift card?',
    answer:
      'To redeem a gift card, visit our Redemption Page and enter the unique code provided by the purchaser. You can also enter this code at checkout. The gift card amount will be added as credit to your account, which can be used on your next purchase.',
  },
  {
    question: 'Do I need an account to redeem a gift card?',
    answer:
      'Yes, you need an account to redeem your gift card. You need an account because the gift card amount gets added on your account as a credit.',
  },
  {
    question: 'How do I check my remaining credit balance?',
    answer:
      'Once you have added the gift card amount onto your account as a credit, you can check your credit balance using the My Credits page in your menu.',
  },
  {
    question: 'What if the total of my purchase exceeds my credit balance?',
    answer:
      'If your order total exceeds the credit balance on your account, the remaining amount will be charged to your payment method on file during checkout.',
  },
];
